// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a7e164a","732":"b332e469","977":"89980f65"}[chunkId] + ".chunk.js";
};